import { colorBaseBlue50, colorBaseBlue600, colorBaseBlue75, colorBaseGreen50, colorBaseGreen700, colorBaseGreen75, colorBaseNeutral50, colorBaseNeutral700, colorBaseNeutral75, colorBaseNeutralWhite, colorBaseOrange50, colorBaseOrange500, colorBaseOrange75, colorBaseRed50, colorBaseRed500, colorBaseRed75, colorBaseYellow50, colorBaseYellow600, colorBaseYellow75, colorBrandPrimaryBoldest } from '@duxton-web/design-tokens/themes/light';
import { PresetColors } from '../interface';
// Dui start
const DuxtonTagPresets = ['white', 'grey', 'green', 'blue', 'red', 'orange', 'yellow', 'darkgreen'];
export const isDuxtonTagPresetsType = function () {
  let color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'white';
  return DuxtonTagPresets.includes(color);
};
const duxtonColorMap = {
  white: {
    color: colorBaseNeutral700,
    background: colorBaseNeutralWhite,
    borderColor: colorBaseNeutral75
  },
  grey: {
    color: colorBaseNeutral700,
    background: colorBaseNeutral50,
    borderColor: colorBaseNeutral75
  },
  green: {
    color: colorBaseGreen700,
    background: colorBaseGreen50,
    borderColor: colorBaseGreen75
  },
  // Dui start
  darkgreen: {
    color: colorBaseGreen700,
    background: colorBrandPrimaryBoldest,
    borderColor: colorBaseGreen75
  },
  // Dui end
  blue: {
    color: colorBaseBlue600,
    background: colorBaseBlue50,
    borderColor: colorBaseBlue75
  },
  red: {
    color: colorBaseRed500,
    background: colorBaseRed50,
    borderColor: colorBaseRed75
  },
  orange: {
    color: colorBaseOrange500,
    background: colorBaseOrange50,
    borderColor: colorBaseOrange75
  },
  yellow: {
    color: colorBaseYellow600,
    background: colorBaseYellow50,
    borderColor: colorBaseYellow75
  }
};
export default function genPresetColor(token, genCss) {
  // Dui start
  return PresetColors.reduce((prev, colorKey) => {
    if (isDuxtonTagPresetsType(colorKey)) {
      const lightColor = duxtonColorMap[colorKey].background;
      const lightBorderColor = duxtonColorMap[colorKey].borderColor;
      const textColor = duxtonColorMap[colorKey].color;
      const darkColor = duxtonColorMap[colorKey].color;
      return Object.assign(Object.assign({}, prev), genCss(colorKey, {
        lightColor,
        lightBorderColor,
        darkColor,
        textColor
      }));
    }
    // Dui end
    const lightColor = token[`${colorKey}1`];
    const lightBorderColor = token[`${colorKey}3`];
    const darkColor = token[`${colorKey}6`];
    const textColor = token[`${colorKey}7`];
    return Object.assign(Object.assign({}, prev), genCss(colorKey, {
      lightColor,
      lightBorderColor,
      darkColor,
      textColor
    }));
  }, {});
}